import { SVGFC } from '@repo/toolkit/types'

const LockOpenIcon: SVGFC = ({ color, ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_6923_150964)">
        <path d="M6.5999 10.2V8.4C6.5999 6.96783 7.16883 5.59432 8.18153 4.58162C9.19422 3.56893 10.5677 3 11.9999 3C13.4321 3 14.8056 3.56893 15.8183 4.58162C16.831 5.59432 17.3999 6.96783 17.3999 8.4H14.6999V10.2H18.2999C18.7773 10.2 19.2351 10.3896 19.5727 10.7272C19.9103 11.0648 20.0999 11.5226 20.0999 12V19.2C20.0999 19.6774 19.9103 20.1352 19.5727 20.4728C19.2351 20.8104 18.7773 21 18.2999 21H5.6999C5.22251 21 4.76468 20.8104 4.42711 20.4728C4.08954 20.1352 3.8999 19.6774 3.8999 19.2V12C3.8999 11.01 4.7099 10.2 5.6999 10.2H6.5999ZM11.0999 16.257V18.3H12.8999V16.257C13.2431 16.0589 13.5113 15.7531 13.6629 15.387C13.8145 15.0209 13.8411 14.615 13.7386 14.2323C13.636 13.8495 13.41 13.5113 13.0957 13.2701C12.7813 13.0289 12.3961 12.8982 11.9999 12.8982C11.6037 12.8982 11.2185 13.0289 10.9041 13.2701C10.5898 13.5113 10.3638 13.8495 10.2612 14.2323C10.1587 14.615 10.1853 15.0209 10.3369 15.387C10.4886 15.7531 10.7567 16.0589 11.0999 16.257ZM9.2999 8.4V10.2H14.6999V8.4C14.6999 7.68392 14.4154 6.99716 13.9091 6.49081C13.4027 5.98446 12.716 5.7 11.9999 5.7C11.2838 5.7 10.5971 5.98446 10.0907 6.49081C9.58437 6.99716 9.2999 7.68392 9.2999 8.4Z" />
      </g>
      <defs>
        <clipPath id="clip0_6923_150964">
          <rect width="18" height="18" transform="translate(3 3)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default LockOpenIcon
